var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('iw-input-checkbox',{staticClass:"field",attrs:{"input-label":_vm.$t('furnished'),"name":"is-furnished"},model:{value:(_vm.isFurnished),callback:function ($$v) {_vm.isFurnished=$$v},expression:"isFurnished"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }